/* eslint-disable */
import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CheckCheck, BellOff, BellRing } from 'lucide-react';
import NotificationRow from './NotificationRow';
import { getPermission, requestPermission } from './desktopNotification';

/* Popover body. All data + actions come in via props (see NotificationBell). */

export default function NotificationsPanel({
  items, loading, unreadCount, onMarkAllRead, onApprove, onReject, onOpen, busyIds, onViewAll,
}) {
  const isBusy = (id) => Boolean(busyIds && busyIds[id]);

  /*
   * Offered here, and only while the answer is still 'default', because the browser
   * only accepts a permission request that came from a user gesture — opening this
   * panel and clicking is one. Asking on page load is both ignored by Safari and
   * wasted: a dismissed prompt cannot be raised again, so it is worth spending on
   * someone who has just shown they care about notifications.
   *
   * 'denied' and 'unsupported' render nothing. There is no way back from denied except
   * the browser's own site settings, so a button here would do nothing but mislead.
   */
  const [permission, setPermission] = useState(getPermission);
  const enableDesktopAlerts = async () => setPermission(await requestPermission());
  const groups = [
    { key: 'new', label: 'New', rows: items.filter((i) => i.unread) },
    { key: 'earlier', label: 'Earlier', rows: items.filter((i) => !i.unread) },
  ].filter((g) => g.rows.length);

  return (
    <div className="shoot-notif-panel">
      <div className="shoot-notif-head">
        <span className="shoot-notif-title">Notifications</span>
        <button
          type="button"
          className="shoot-notif-markall"
          onClick={onMarkAllRead}
          disabled={!unreadCount}
        >
          <CheckCheck size={15} strokeWidth={2} />
          Mark all as read
        </button>
      </div>

      {permission === 'default' ? (
        <button
          type="button"
          className="shoot-notif-perm"
          onClick={enableDesktopAlerts}
        >
          <BellRing size={14} strokeWidth={2} />
          Turn on desktop alerts
          <span className="sub">Get notified when this tab is in the background</span>
        </button>
      ) : null}

      <div className="shoot-notif-scroll">
        {loading ? (
          <div className="shoot-notif-empty"><p>Loading…</p></div>
        ) : !items.length ? (
          <div className="shoot-notif-empty">
            <span className="ic"><BellOff size={22} strokeWidth={1.8} /></span>
            <p>You&apos;re all caught up</p>
            <span className="sub">Approvals and updates for you will show up here.</span>
          </div>
        ) : (
          groups.map((g) => (
            <div key={g.key}>
              <div className="shoot-notif-grouplabel">{g.label}</div>
              {g.rows.map((item) => (
                <NotificationRow
                  key={item.id}
                  item={item}
                  busy={isBusy(item.id)}
                  onApprove={onApprove}
                  onReject={onReject}
                  onOpen={onOpen}
                />
              ))}
            </div>
          ))
        )}
      </div>

      {items.length ? (
        <div className="shoot-notif-foot">
          <button type="button" onClick={onViewAll}>View all notifications</button>
        </div>
      ) : null}
    </div>
  );
}
